import React from 'react'
import CreateQuestion from '../../../components/organisms/admin/question/CreateQuestion'

type Props = {}

const CreateQuestionPage = (props: Props) => {
  return (
    <CreateQuestion />
  )
}

export default CreateQuestionPage